<div class="ds-card small">
  <div *ngIf="project.image" class="ds-card-image">
    <img [src]="project.image" alt="Project image" />
  </div>
  <div class="ds-card-content">
    <app-ds-badge *ngIf="badge.type !== 'hidden'" [type]="badge.type">
      {{('GROW.project.customerInvestmentStatus.' + badge.key +'.name') | translate}}
    </app-ds-badge>
    <h4 class="ds-caption-1">{{project.title}}</h4>
    <p class="ds-ui-3 ds-color-core-neutral-8">
      {{ project.expected_return | percent:'1.1'}} {{ 'GROW.project.perAnnum' | translate }} · {{'GROW.project.until' | translate}} {{ project.end_date |
      dateTranslate:'shortMonth': language | translate}}
    </p>
  </div>
</div>
